import { Link } from 'gatsby'
import React from 'react'
import Helmet from 'react-helmet'
import { Waypoint } from 'react-waypoint'
//import i18n from './i18n'
import Header from '../components/Header'
import Layout from '../components/layout'
import Nav from '../components/Nav'
import GrammarChecker from '../components/GrammarChecker'

import logoCitius from '../assets/images/cituis.jpeg'
import pic01 from '../assets/images/pic01.jpg'
import logoUsc from '../assets/images/usc.jpeg'
import i18n from '../components/i18n'

class Index extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      stickyNav: false,
    }
    i18n.changeLanguage('en')
  }

  _handleWaypointEnter = () => {
    this.setState(() => ({ stickyNav: false }))
  }

  _handleWaypointLeave = () => {
    this.setState(() => ({ stickyNav: true }))
  }

  render() {
    return (
      <Layout>
        <Helmet title="Avalingua demo" />

        <Header />

        <Waypoint
          onEnter={this._handleWaypointEnter}
          onLeave={this._handleWaypointLeave}
        ></Waypoint>
        <Nav sticky={this.state.stickyNav} />

        <div id="main">
          <section id="intro" className="main">
            <div className="spotlight">
              <div className="content">
                <header className="major">
                  <h2>What is Avalingua?</h2>
                </header>
                <p>
                  Avalingua automatically evaluates the linguistic quality of
                  texts, both in Galician and Spanish (the Portuguese version is
                  in process). From a written text or a set of texts, Avalingua
                  makes a detailed analysis using different natural language
                  processing tools, including a syntactic dependency analyser,
                  and various language resources. It has been developed by the
                  Tecnoloxías da Linguaxe Natural program of CiTIUS, University
                  of Santiago de Compostela, Galiza.
                </p>
                <ul className="actions">
                  <li>
                    <Link to="/info" className="button">
                      Learn More
                    </Link>
                  </li>
                </ul>
              </div>
              <span className="image">
                <img src={pic01} alt="" />
              </span>
            </div>
          </section>

          <section id="first" className="main special">
            <header className="major">
              <h2>Features</h2>
            </header>
            <ul className="features">
              <li>
                <span className="icon major style1 fa-code"></span>
                <h3>Online</h3>
                <p>
                  It is executed in a web application. There is no need to
                  download anything.
                </p>
              </li>
              <li>
                <span className="icon major style3 fa-copy"></span>
                <h3>Based on DepPattern</h3>
                <p>
                  The software contains a compiler that generates parsers from
                  DepPattern-based grammars for each language.
                </p>
              </li>
              <li>
                <span className="icon major style5 fa-diamond"></span>
                <h3>Advanced corrections</h3>
                <p>
                  Avalingua does not only correct your grammar. It also gives an
                  extensive explanation to help you avoid making the same
                  mistakes.
                </p>
              </li>
            </ul>
            {/*<footer className="major">*/}
            {/*  <ul className="actions">*/}
            {/*    <li>*/}
            {/*      <Link to="/generic" className="button">*/}
            {/*        Learn More*/}
            {/*      </Link>*/}
            {/*    </li>*/}
            {/*  </ul>*/}
            {/*</footer>*/}
          </section>

          <GrammarChecker />

          {/*<section id="second" className="main special">*/}
          {/*  <header className="major">*/}
          {/*    <h2>Try our grammar checker</h2>*/}
          {/*    <p>Select your language and introduce your text.</p>*/}
          {/*    <GrammarChecker />*/}
          {/*  </header>*/}
          {/*  <ul className="statistics">*/}
          {/*    <li className="style1">*/}
          {/*      <span className="icon fa-exclamation-triangle"></span>*/}
          {/*      <strong>5,120</strong> Grammar errors*/}
          {/*    </li>*/}
          {/*    <li className="style2">*/}
          {/*      <span className="icon fa-exclamation-circle"></span>*/}
          {/*      <strong>8,192</strong> Lexical errors*/}
          {/*    </li>*/}
          {/*    <li className="style3">*/}
          {/*      <span className="icon fa-signal"></span>*/}
          {/*      <strong>2,048</strong> Grammar warnings*/}
          {/*    </li>*/}
          {/*    <li className="style4">*/}
          {/*      <span className="icon fa-laptop"></span>*/}
          {/*      <strong>4,096</strong> Lexical warnings*/}
          {/*    </li>*/}
          {/*    <li className="style5">*/}
          {/*      <span className="icon fa-diamond"></span>*/}
          {/*      <strong>1,024</strong> Nullam*/}
          {/*    </li>*/}
          {/*  </ul>*/}

          {/*  <ul className="statistics">*/}
          {/*    <li className="style1">*/}
          {/*      <span className="icon fa-keyboard"></span>*/}
          {/*      <strong>5,125</strong> Words in the text*/}
          {/*    </li>*/}
          {/*    <li className="style2">*/}
          {/*      <span className="icon fa-folder-open-o"></span>*/}
          {/*      <strong>8,192</strong> Grammatical score*/}
          {/*    </li>*/}
          {/*    <li className="style3">*/}
          {/*      <span className="icon fa-spell-check"></span>*/}
          {/*      <strong>2,048</strong> Lexical score*/}
          {/*    </li>*/}

          {/*    <li className="style4">*/}
          {/*      <span className="icon fa-signal"></span>*/}
          {/*      <strong>4,096</strong> Total score*/}
          {/*    </li>*/}
          {/*  </ul>*/}
          {/*  <p className="content">*/}
          {/*    Nam elementum nisl et mi a commodo porttitor. Morbi sit amet nisl*/}
          {/*    eu arcu faucibus hendrerit vel a risus. Nam a orci mi, elementum*/}
          {/*    ac arcu sit amet, fermentum pellentesque et purus. Integer maximus*/}
          {/*    varius lorem, sed convallis diam accumsan sed. Etiam porttitor*/}
          {/*    placerat sapien, sed eleifend a enim pulvinar faucibus semper quis*/}
          {/*    ut arcu. Ut non nisl a mollis est efficitur vestibulum. Integer*/}
          {/*    eget purus nec nulla mattis et accumsan ut magna libero. Morbi*/}
          {/*    auctor iaculis porttitor. Sed ut magna ac risus et hendrerit*/}
          {/*    scelerisque. Praesent eleifend lacus in lectus aliquam porta. Cras*/}
          {/*    eu ornare dui curabitur lacinia.*/}
          {/*  </p>*/}
          {/*  <footer className="major">*/}
          {/*    <ul className="actions">*/}
          {/*      <li>*/}
          {/*        <Link to="/generic" className="button">*/}
          {/*          Learn More*/}
          {/*        </Link>*/}
          {/*      </li>*/}
          {/*    </ul>*/}
          {/*  </footer>*/}
          {/*</section>*/}

          <section id="cta" className="main special">
            <header className="major">
              <h2>Development Team</h2>
              {/* <p>
                Donec imperdiet consequat consequat. Suspendisse feugiat congue
                <br />
                posuere. Nulla massa urna, fermentum eget quam aliquet.
              </p> */}
              <div className="organization-wrapper">
                <div className="organization">
                  <img src={logoCitius} alt="Citius" />
                  <h4>
                    Centro Singular de Investigación en Tecnoloxías Intelixentes
                  </h4>
                  <ul>
                    <li>
                      <a
                        href="https://isaacgonzalez.eu/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Isaac González-López
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://citius.usc.es/equipo/investigadores-postdoutorais/marcos-garcia-gonzalez"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Marcos Garcia, CiTIUS
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://citius.usc.es/equipo/persoal-adscrito/pablo-gamallo-otero"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Pablo Gamallo, CiTIUS
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="organization">
                  <img src={logoUsc} alt="USC" />
                  <h4>University of Santiago de Compostela</h4>
                  <span>
                    Founded in 1495, The University of Santiago de Compostela,
                    USC is the main university of Galicia, and is currently in
                    the top 5 of Spanish Universities. The research group
                    ProLNat@GE from the USC also took part in the development of
                    this tool.
                  </span>
                </div>
              </div>
            </header>
            {/*<footer className="major">*/}
            {/*  <ul className="actions">*/}
            {/*    <li>*/}
            {/*      <Link to="/generic" className="button special">*/}
            {/*        Get Started*/}
            {/*      </Link>*/}
            {/*    </li>*/}
            {/*    <li>*/}
            {/*      <Link to="/generic" className="button">*/}
            {/*        Learn More*/}
            {/*      </Link>*/}
            {/*    </li>*/}
            {/*  </ul>*/}
            {/*</footer>*/}
          </section>
        </div>
      </Layout>
    )
  }
}

export default Index
